import React, { FC } from 'react';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { t } from 'i18next';
import GroupsDistribution from './GroupsDistribution/GroupsDistribution';
import ProgressBar from './ProgressBar/ProgressBar';
import { EScore, EScoreRating } from '../../../../services/individualReport';
import { THEME as theme } from '../../../../styles/theme';

const styles = StyleSheet.create({
  card: {
    display: 'flex',
    height: 48,
    padding: `${theme.layout.spacing.nano} ${theme.layout.spacing.decy}`,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    backgroundColor: theme.colors.neutral.primary[0],
  },
  content: {
    display: 'flex',
    width: 196,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
  },
  title: {
    maxWidth: 120,
    fontFamily: 'Roboto-Bold',
    fontSize: 12,
  },
  score: {
    width: 64,
    padding: `0 ${theme.layout.spacing.mikro}`,
    fontFamily: 'Roboto-Bold',
    fontSize: 12,
    color: theme.colors.neutral.primary[60],
    textAlign: 'center',
  },
  progress: {
    display: 'flex',
  },
});

interface ISummaryCard {
  distribution: number[];
  mode: 'results' | 'group';
  score: EScore;
  score_rating: EScoreRating;
  title: string;
  code: string;
  hasBorder: boolean;
}

const SummaryCard: FC<ISummaryCard> = ({
  distribution,
  mode,
  score,
  score_rating,
  title,
  code,
  hasBorder,
}) => (
  <View
    style={[
      styles.card,
      { borderBottom: hasBorder ? `1px solid ${theme.colors.neutral.primary[30]}` : 'none' },
    ]}
  >
    <View style={styles.content}>
      <Text style={styles.title}>{title}</Text>
      <Text style={styles.score}>{t(`results.report.predictiveStates.score.${score}`)}</Text>
    </View>
    <View style={styles.progress}>
      {mode === 'results' ? <ProgressBar {...{ score, score_rating }} /> : null}
      {mode === 'group' ? <GroupsDistribution {...{ distribution, score_rating, code }} /> : null}
    </View>
  </View>
);

export default SummaryCard;
